import { render, staticRenderFns } from "./PersonalInfoFormV2.vue?vue&type=template&id=676e1525&scoped=true"
import script from "./PersonalInfoFormV2.vue?vue&type=script&lang=js"
export * from "./PersonalInfoFormV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676e1525",
  null
  
)

export default component.exports